"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RealStartEndTimeCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var timezone = state.user.timezone;
  return {
    timezone: timezone
  };
};

var RealStartEndTimeCell = function RealStartEndTimeCell(_ref) {
  var cellData = _ref.cellData,
      timezone = _ref.timezone,
      intl = _ref.intl;
  var _cellData$date = cellData.date,
      date = _cellData$date === void 0 ? null : _cellData$date,
      _cellData$startBy = cellData.startBy,
      startBy = _cellData$startBy === void 0 ? null : _cellData$startBy,
      _cellData$stopBy = cellData.stopBy,
      stopBy = _cellData$stopBy === void 0 ? null : _cellData$stopBy;
  var Icon = null;

  if (startBy === 'MANUALLY' || stopBy === 'MANUALLY') {
    Icon = /*#__PURE__*/_react["default"].createElement("span", {
      className: "ml-2",
      title: startBy ? intl.formatMessage({
        id: 'widgets.tourBoard.manuallyTourStarted'
      }) : intl.formatMessage({
        id: 'widgets.tourBoard.manuallyTourStopped'
      })
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ManuallyTourStart, null));
  } else if (stopBy === 'SYSTEM') {
    Icon = /*#__PURE__*/_react["default"].createElement("span", {
      className: "ml-2",
      title: intl.formatMessage({
        id: 'widgets.tourBoard.automaticallyTourStopped'
      })
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.AutomaticallyTourStart, null));
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, date ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: date,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: timezone
  })) : null, Icon);
};

exports.RealStartEndTimeCell = RealStartEndTimeCell;
RealStartEndTimeCell.propTypes = {
  intl: _nicbaseTranslation.intlShape.isRequired,
  cellData: _propTypes["default"].string.isRequired,
  timezone: _propTypes["default"].string.isRequired
};
var ConnectedDateCell = (0, _reactRedux.connect)(mapStateToProps)((0, _nicbaseTranslation.injectIntl)(RealStartEndTimeCell));

var renderer = function renderer(_ref2) {
  var cellData = _ref2.cellData;
  return /*#__PURE__*/_react["default"].createElement(ConnectedDateCell, {
    cellData: cellData
  });
};

renderer.propTypes = {
  cellData: _propTypes["default"].shape({})
};
renderer.defaultProps = {
  cellData: {}
};
var _default = renderer;
exports["default"] = _default;